import { Component } from '@opten/compiler/metadata/component';
import { removeClass } from '@opten/dom/remove-class';
import { addClass } from '@opten/dom/add-class';
import { Header } from '../header/header';
import { ComponentRef } from '@opten/compiler/metadata/di';

@Component({ className: 'js-back-to-top' })
export class BackToTopComponent {
	private _bodyElement: HTMLElement;
	@ComponentRef(Header) _headerElement: Header;

	constructor(private element: HTMLElement) {
		this._bodyElement = document.body;
		element.addEventListener('click', () => {
			this.animate();
		});
	}

	private animate() {
		window.scrollTo(0, 0);
		this._headerElement._update(0);
		removeClass(this._bodyElement, 'going-up');
		addClass(this._bodyElement, 'going-down');
	}
}
